export const ERROR_CONSTANTS = {
  BOARD_ERROR: 'error.board_error',
  STATUS_ERROR: 'error.status_error',
  MONDAY_ERROR: 'error.monday_error',
};
